import type { VehiclePopupState } from './reducer';
import { compose } from 'redux';

import type { AppState } from '../AppState';

export const selectVehiclePopupDomain = (state: AppState): VehiclePopupState => state.vehiclePopup;

export const selectAddress = compose((domainState: VehiclePopupState) => domainState.addressWebData, selectVehiclePopupDomain);
